export default __webpack_public_path__ + "static/media/t14.793c4cda.jpg";